import { updateActionErrors } from './updateErrors';
import {
    ADD_UNIT_UTILITY, ADD_UTILITIES_BULK, DELETE_UNIT_UTILITY, BULK_CREATE_UTILITY_INVOICES,
    FETCH_PROPERTY_UTILITIES, FETCH_UNIT_UTILITIES, UPDATE_UNIT_UTILITY, RESET_UTILITIES
} from '../actions/actionTypes';
import graphqlClient from '../../api/axios_interceptor';
import {
    addUnitUtilityMutation, addUtilitiesBulkQuery, deleteUnitUtilityMutation,
    getPropertyUnitUtilitiesQuery, getUnitUtilitiesQuery, updateUnitUtilityMutation,
    createUtilityInvoices, resetUtilitiesMutation
} from '../../api/graphql/queries/unitUtilities';

export const parseUnitUtility = (utility) => {
    let invoiceId = "";
    let invoiceAmount = "";
    if(utility.invoice){
        invoiceId = utility.invoice.id;
        invoiceAmount = utility.invoice.amount;
    }
    return ({
        utilityId: utility.utilityId,
        unit: utility.unit.id,
        date: utility.date,
        item: utility.item,
        previousReading: utility.previousReading,
        currentReading: utility.currentReading,
        invoiceId,
        invoiceAmount,
        createdTs: utility.createdTs,
        updated: utility.updated
    })
};


export const fetchUnitUtilitiesMiddleware = async (action) => {
    let unitUtility = action.payload;
    try {
        let unitUtilities = {};
        let invoices = {};
        let query = getUnitUtilitiesQuery(unitUtility.propertyIds, unitUtility.unitIds,
            unitUtility.startDate, unitUtility.endDate, unitUtility.utilityItems, unitUtility.offset)
        await graphqlClient({
            data: {
                query: query
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if ((queryResult.data.data.unitUtilities.utilities).length != 0) {
                queryResult.data.data.unitUtilities.utilities.map((utility) => {
                    unitUtilities[utility.utilityId] = parseUnitUtility(utility);
                });
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        unitUtilities,
                        invoices
                    },
                    offset: queryResult.data.data.unitUtilities.next
                });
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        unitUtilities,
                        invoices
                    },
                    offset: ""
                });
            }


        })
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const fetchPropertyUnitUtilitiesMiddleware = async (action) => {
    let unitUtility = action.payload;
    try {
        let unitUtilities = {};
        let query = getPropertyUnitUtilitiesQuery(unitUtility.propertyIds, unitUtility.unitIds, unitUtility.utilityItem)
        await graphqlClient({
            data: {
                query: query
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if ((queryResult.data.data.utilities).length != 0) {
                queryResult.data.data.utilities.map((utility) => {
                    unitUtilities[utility.unit.id] = parseUnitUtility(utility);
                });
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        unitUtilities

                    }
                });
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        unitUtilities
                    },
                });
            }


        })
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const addUtilitiesBulkMiddleware = async (action) => {
    let payload = action.payload;
    let unitUtilities = {};
    try {
        await graphqlClient({
            data: {
                query: addUtilitiesBulkQuery(payload)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            }else if (queryResult.data.data.addUtilitiesBulk.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.addUtilitiesBulk.errorMessage);
            }else {
                queryResult.data.data.addUtilitiesBulk.unitUtilities.map((utility) => {
                    unitUtilities[utility.unit.id] = parseUnitUtility(utility);
                });
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        unitUtilities
                    }
                });
            }
        });

    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error)
    }

    return action;
}


const addUnitUtilityMiddleware = async (action) => {
    let unitUtility = action.payload;
    try {
        await graphqlClient({
            data: {
                query: addUnitUtilityMutation(unitUtility.unitId, unitUtility.date, unitUtility.item, unitUtility.currentReading,
                    unitUtility.previousReading, unitUtility.invoiceId)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.addUnitUtility.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.addUnitUtility.errorMessage);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        unitUtility: parseUnitUtility(queryResult.data.data.addUnitUtility.unitUtility)
                    }
                });
            }
        });

    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error)
    }

    return action;
}

const updateUnitUtilityMiddleware = async (action) => {
    let unitUtility = action.payload;
    try {
        await graphqlClient({
            data: {
                query: updateUnitUtilityMutation(unitUtility.utilityId, unitUtility.unitId, unitUtility.date, unitUtility.item, unitUtility.currentReading,
                    unitUtility.previousReading, unitUtility.invoiceId)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else if (queryResult.data.data.updateUnitUtility.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.updateUnitUtility.errorMessage);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        unitUtility: parseUnitUtility(queryResult.data.data.updateUnitUtility.unitUtility)
                    }
                });
            }

        })
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error)
    }

    return action;
}

const deleteUnitUtilityMiddleware = async (action) => {
    let unitUtility = action.payload;
    try {

        await graphqlClient({
            data: {
                query: deleteUnitUtilityMutation(unitUtility.utilityId)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.deleteUnitUtility.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.deleteUnitUtility.errorMessage);
            }
        })
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
    }

    return action;
}

const bulkCreateInvoicesMiddleware = async (action) => {
    let payload = action.payload;
    try{
        const query = createUtilityInvoices(payload.utilityIds);
        await graphqlClient({
            data: { query }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, error)
            }else{
                const data = queryResult.data.data.createUtilityInvoices;
                const utilities = data.utilities.map((utility) => parseUnitUtility(utility));
                payload = {
                    ...payload,
                    errors: data.errors,
                    feedbackSummary: data.feedbackSummary,
                    utilities
                }
                action.payload = { ...payload };
            }
        })
    }catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const resetUtilitiesMiddleware = async (action) => {
    let payload = action.payload;
    try {
        await graphqlClient({
            data: {
                query: resetUtilitiesMutation(payload)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.resetMeterReadings.success === false) {
                action = updateActionErrors(action, queryResult.data.data.resetMeterReadings.message);
            } else {
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        message: queryResult.data.data.resetMeterReadings.message
                    }
                });
            }
        });
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const unitUtilitiesMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case ADD_UNIT_UTILITY:
            action = await addUnitUtilityMiddleware(action);
            break;
        case ADD_UTILITIES_BULK:
            action = await addUtilitiesBulkMiddleware(action);
            break;
        case UPDATE_UNIT_UTILITY:
            action = await updateUnitUtilityMiddleware(action);
            break;
        case DELETE_UNIT_UTILITY:
            action = await deleteUnitUtilityMiddleware(action);
            break;
        case FETCH_UNIT_UTILITIES:
            action = await fetchUnitUtilitiesMiddleware(action);
            break;
        case FETCH_PROPERTY_UTILITIES:
            action = await fetchPropertyUnitUtilitiesMiddleware(action);
            break;
        case BULK_CREATE_UTILITY_INVOICES:
            action = await bulkCreateInvoicesMiddleware(action);
            break;
        case RESET_UTILITIES:
            action = await resetUtilitiesMiddleware(action);
            break;
        default:
            break;
    }
    return next(action);
};

export {
    unitUtilitiesMiddleware
}